import { render, staticRenderFns } from "./RegisterTypeForm.vue?vue&type=template&id=2dd92045&scoped=true&"
import script from "./RegisterTypeForm.vue?vue&type=script&lang=js&"
export * from "./RegisterTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTypeForm.vue?vue&type=style&index=0&id=2dd92045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd92045",
  null
  
)

export default component.exports